<template>
  <header
    class="relative mx-auto h-auto w-full max-w-screen-2xl border-b border-gray-100 bg-white xs:px-4 xs:pb-2 xs:pt-2.5"
    data-testid="reduced-header"
  >
    <div class="flex items-center justify-between">
      <!-- Left: Logo -->
      <div class="flex items-center justify-start">
        <SFLocalizedLink
          :to="routeList.home"
          raw
          :aria-label="shopName"
          data-testid="reduced-header-logo"
          class="h-auto max-w-[131px]"
        >
          <IconLogo
            class="h-auto w-full xs:max-w-[80px] sm:max-w-full"
            aria-hidden="true"
          />
        </SFLocalizedLink>
      </div>

      <!-- Right: Security Message with Lock Icon -->
      <div class="flex items-center space-x-2 text-gray-400">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="13"
          fill="currentColor"
          class="text-gray-400"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M8.389 3.404a2.892 2.892 0 0 0-5.781.145v1.83h-.06c-.945 0-1.711.766-1.711 1.711v3.542c0 .945.766 1.712 1.712 1.712H8.45c.946 0 1.712-.767 1.712-1.712V7.09c0-.945-.766-1.712-1.712-1.712h-.059v-1.83l-.003-.144ZM7.33 5.378v-1.83a1.83 1.83 0 0 0-3.656-.115l-.004.116v1.83h3.66ZM2.549 6.441H8.45c.36 0 .65.29.65.65v3.54a.65.65 0 0 1-.65.65H2.55a.65.65 0 0 1-.65-.65v-3.54c0-.36.291-.65.65-.65ZM5.5 7.74a1.122 1.122 0 1 0 0 2.243 1.122 1.122 0 0 0 0-2.243Z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="text-sm font-normal text-gray-500">
          {{ $t('checkout_page.security_notice') }}
        </span>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import SFLocalizedLink from '../../SFLocalizedLink.vue'
import { useNuxtApp } from '#app/nuxt'
import { routeList } from '~/utils/route'

const {
  $config: {
    public: { shopName },
  },
} = useNuxtApp()
</script>
